import * as path from 'path';
import { MenuType, MenuRouteType } from 'modules/types/account';
import _ from 'lodash';
import MyWorkBenchList from '../containers/OutWorkbenchPortal/index';
import OutWorkbenchList from '../containers/OutWorkbench/components/List';
import OutBiddingList from '../containers/OutBidding/components/NewList/index';

const makeRoute = (
  menus: MenuType[],
  routes: any[],
  parentRoutePath: string = '',
  parentComponentPath: string = '',
) => {
  menus.forEach((menu: MenuType) => {
    const routePath = path.join(parentRoutePath, _.camelCase(menu.key));
    const componentPath = path.join(parentComponentPath, _.upperFirst(_.camelCase(menu.key)));
    const route: any = {
      routePath,
      componentPath,
    };
    if (!!menu.default) {
      routes.push({
        ...route,
        parentRoutePath,
        redirect: true,
      });
    }

    // 递归菜单
    if (menu.children && menu.children.length) {
      if (!menu.children.some((m: MenuType) => !!m.default)) {
        menu.children[0].default = true;
      }
      makeRoute(menu.children, routes, routePath, componentPath);
    } else {
      let component;
      try {
        const path = ['OutWorkbenchPortal', 'OutWorkbench', 'OutBidding'].find(p => componentPath.indexOf(p) > -1)
        if (path) {
          const listMap = {
            OutWorkbenchPortal: MyWorkBenchList,
            OutWorkbench: OutWorkbenchList,
            OutBidding: OutBiddingList
          }
          component = listMap[path as keyof typeof listMap];
          route.childMenus = menus;
        } else {
          component = require('../containers/' + componentPath + '/index').default;
        }
        // component = require('../containers/' + componentPath + '/index').default;
      } catch (e) {
        console.error('make route require error: ', e);
      }
      if (component) {
        routes.push({
          ...route,
          component,
        });
      }
    }
  });
};

const makeRoutes = (menus: MenuType[]): MenuRouteType[] => {
  const routes: MenuRouteType[] = [];
  makeRoute(menus, routes);
  if (routes.length) {
    routes.push({
      ...routes[0],
      parentRoutePath: '',
    });
  }
  return routes;
};

export { makeRoutes };
